var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 6,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#dcdcdc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m1 1 3.5 4L8 1"
  })));
};
export { SvgChevronDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZwogIHdpZHRoPSI5IgogIGhlaWdodD0iNiIKICB2aWV3Qm94PScwIDAgOSA2JwogIGZpbGw9J25vbmUnCiAgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJwo+CiAgPHBhdGgKICAgIGQ9J00xIDFMNC41IDVDNS44NjY4MyAzLjQzNzkgNi42MzMxNyAyLjU2MjEgOCAxJwogICAgc3Ryb2tlPSdnYWluc2Jvcm8nCiAgICBzdHJva2Utd2lkdGg9JzInCiAgICBzdHJva2UtbGluZWNhcD0ncm91bmQnCiAgICBzdHJva2UtbGluZWpvaW49J3JvdW5kJwogIC8+Cjwvc3ZnPgo=";